import { useMutation } from '@tanstack/react-query';
import { patchUserPreference } from '../requests';
import type { PatchUserPreferenceRequest } from '../types';

/**
 * Raw PATCH mutation for a user preference layer. Intentionally does NOT
 * manage cache here — the owning hook (`useUserPreference`) controls cache
 * writes so it can guard against races between an in-flight mutation
 * response and a newer optimistic update.
 */
export const usePatchUserPreference = <T extends Record<string, unknown>>() =>
  useMutation({
    mutationFn: (params: PatchUserPreferenceRequest<T>) =>
      patchUserPreference<T>(params),
  });
